import React from "react";
import { BillingMethodTabComponent } from "./render";

type Props = {
    prefix: "CarePlanBilling";
    parent: string
}

export const BillingMethodTab: React.FC<Props> = ({ prefix, parent }) => {
    return (
        <BillingMethodTabComponent parent={parent} prefix={prefix} />
    )
};

export default React.memo(BillingMethodTab)